import React, { Component } from 'react';
import Navbar from '../../components/Navbar';
import ProjectCard from '../../components/ProjectCard';
import Footer from '../../components/Footer';
import {
  Container, 
  Blurb, 
  Wrapper, 
  WrapCaption, 
  WrapProjects
} from './styles';
import project1 from '../../assets/images/be-the-hero.png';
import project2 from '../../assets/images/to-do-list.png';
import project3 from '../../assets/images/ecoleta.png';
import project4 from '../../assets/images/tetris.png';
import project5 from '../../assets/images/chromatica-game.png';
import project6 from '../../assets/images/happy.png';
import project7 from '../../assets/images/spaces-scheduling.png';

export default class About extends Component {
  render() {
    return (
      <>
        <Container>
          <Navbar />
          <Blurb>
            <Wrapper>
              <WrapCaption>
                <h1>My Projects</h1>
              </WrapCaption>
              <WrapProjects>
              <ProjectCard
                  link="https://github.com/biachacon/spaces-scheduling"
                  img={project7}
                  title="Spaces Scheduling"
                  content="Application to manage the spaces of the computer sector of EAJ."
                />
                <ProjectCard
                  link="https://github.com/BiaChacon/ToDoList"
                  img={project2}
                  title="To Do List"
                  content="Mobile application to manage tasks. To Do List is the simplest and most effective personal productivity tool."
                />
                <ProjectCard
                  link="https://github.com/BiaChacon/tetris"
                  img={project4}
                  title="Tetris"
                  content="Implementation of tetris game for android."
                />
                <ProjectCard
                  link="https://github.com/biachacon/be-the-hero"
                  img={project1}
                  title="Be The Hero"
                  content="Application to help connect people to ONGs incidents in order to contribute to the incident."
                />
                <ProjectCard
                  link="https://github.com/BiaChacon/ecoleta"
                  img={project3}
                  title="Ecoleta"
                  content="Application to help people find waste collection points."
                />
                <ProjectCard
                  link="https://github.com/BiaChacon/happy"
                  img={project6}
                  title="Happy"
                  content="Application to help people find institutional care homes near them so they can visit children."
                />
                <ProjectCard
                  link="https://github.com/BiaChacon/chromatica-game"
                  img={project5}
                  title="Adventures of Chromatica"
                  content="This project is a 2d game in javascript with the objective of jumping from enemies."
                />
              </WrapProjects>
            </Wrapper>
          </Blurb>
        </Container>
        <Footer/>
      </>
    );
  }
}
